import { useEffect } from "react";

function setMetaTag(attr, attrValue, content) {
	let meta = document.querySelector(`meta[${attr}='${attrValue}']`);
	if (!meta) {
		meta = document.createElement("meta");
		meta.setAttribute(attr, attrValue);
		document.head.appendChild(meta);
	}
	meta.setAttribute("content", content);
}

function setLinkTag(rel, href) {
	let link = document.querySelector(`link[rel='${rel}']`);
	if (!link) {
		link = document.createElement("link");
		link.rel = rel;
		document.head.appendChild(link);
	}
	link.href = href;
}

export default function useDynamicHead({
	title,
	favicon,
	description,
	themeColor,
	ogImage,
	lang,
	canonical,
}) {
	useEffect(() => {
		if (favicon) {
			let link = document.querySelector("link[rel='icon']");
			if (!link) {
				link = document.createElement("link");
				link.rel = "icon";
				document.head.appendChild(link);
			}
			const newHref = `${favicon}${
				favicon.includes("?") ? "&" : "?"
			}v=${Date.now()}`;
			link.href = newHref;
		}

		if (title) {
			document.title = title;
			setMetaTag("property", "og:title", title);
			setMetaTag("name", "twitter:title", title);
		}

		if (description) {
			setMetaTag("name", "description", description);
			setMetaTag("property", "og:description", description);
			setMetaTag("name", "twitter:description", description);
		}

		if (ogImage) {
			setMetaTag("property", "og:image", ogImage);
			setMetaTag("name", "twitter:image", ogImage);
			setMetaTag("name", "twitter:card", "summary_large_image");
		}

		if (canonical) {
			setLinkTag("canonical", canonical);
			setMetaTag("property", "og:url", canonical);
		}

		setMetaTag("property", "og:type", "website");

		if (lang) {
			document.documentElement.lang = lang;
		}
	}, [title, favicon, description, ogImage, lang, canonical]);

	useEffect(() => {
		if (!themeColor) return;
		setMetaTag("name", "theme-color", themeColor);
	}, [themeColor]);
}
